define('shared/initializer/form/adapters/mixins/StoreOfferIdIntoState',[
    '../../constants',
    'shared/lib/RSVP',
    'shared/remote/offer/get',
    'shared/util/dispatchers/FormDataDispatcher',
    'shared/util/state/adapters/order',
    'shared/util/state',
    'shared/util/checkout/coupon',
    'shared/util/checkout/RedemptionCodeHelper',
    'shared/lib/cookie'
],
function  (
    constants,
    RSVP,
    getOffer,
    FormDataDispatcher,
    orderAdapter,
    state,
    couponUtil,
    RedemptionCode,
    cookie
) {
    'use strict';
    function Ctor(){}

    Ctor.prototype.doPageLoad = function(){
        var me = this;

        if (!me.redemptionCode) {
            me.redemptionCode = new RedemptionCode(me.options.useRedemptionCode);
        }

        return RSVP.resolve()
            .then(function(){
                return state.adapters.add(orderAdapter);
            })
            .then(function(){
                var dispatcher = new FormDataDispatcher(me.$form);
                var items = {};
                items[constants.State.OrderOfferId] = {
                    sources:
                    [{
                        type: 'query',
                        key: 'offerid'
                    },
                    {
                        retrieve:function(){
                            return RSVP.resolve(cookie.get('et_offerid'));
                        }
                    },
                    {
                        retrieve: function(){
                            return me.redemptionCode.retrieve()
                                .then(function(rCode){
                                    if(!rCode){
                                        return RSVP.resolve(null);
                                    }

                                    return getOffer({redemptionCode: rCode})
                                        .then(function(offer){
                                            if(offer){
                                                return RSVP.resolve(offer.Id.toString());
                                            }
                                            else{
                                                return RSVP.resolve(null);
                                            }
                                        });
                                });
                        },
                        allowUndefined: false
                    },
                    {
                        retrieve: function(){
                            return couponUtil.get()
                                .then(function(couponCode){
                                    if(!couponCode){
                                        return null;
                                    }

                                    return getOffer({couponCode: couponCode})
                                        .then(function(offer){
                                            if(offer){
                                                return offer.Id.toString();
                                            }
                                            else{
                                                return null;
                                            }
                                        });
                                });
                        },
                        allowUndefined: false
                    },
                    {
                        type: 'state',
                        doNotWait: true
                    }, {
                        // TODO: considering move it to payment page when product choice is implemented
                        retrieve: function(){
                            return getOffer()
                                .then(function( offer ){
                                    if ( offer && offer.Id ) {
                                        return offer.Id.toString();
                                    }
                                    else {
                                        return 0;
                                    }
                                }, function() {
                                    return 0;
                                });
                        },
                        allowUndefined: true
                    }],
                    targets:
                    [{
                        type: 'state'
                    }]
                };

                return dispatcher.dispatch({
                    items: items,
                    timeout: 1000 * 60 * 60
                });
            });

    };

    return Ctor;
});
